import { styled } from '@mui/material/styles';
import { ListItemText } from 'shared/mui/List';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids/DatagridConfigurableWithStickyActions/DatagridConfigurableWithStickyActions';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';
import { getColumnStyle } from 'utils';

const StickyDatagridConfigurableWithStickyActions = withDatagridStickyStyles(
  DatagridConfigurableWithStickyActions,
);

export const DatagridConfigurableWithStickyActionsStyled = styled(
  StickyDatagridConfigurableWithStickyActions,
)({
  '& .column-amount': {
    textAlign: 'right',
  },
  '& .column-customerData': {
    minWidth: '146px',
  },
  '& .column-providerExternalError': getColumnStyle(262),

  '& th.MuiTableCell-paddingCheckbox': {
    padding: '13px 16px',
  },
  '& td.MuiTableCell-paddingCheckbox': {
    padding: '13px 16px',
  },
});

export const ListItemTextStyled = styled(ListItemText)({
  '.MuiListItemText-primary': {
    fontSize: '14px',
  },
});
